export function triggerPulse(operatorDetails) {
  if (typeof window !== "undefined") {
    const sdkEnv =
      process.env.REACT_APP_MODE === "PRODUCTION" ? "production" : "staging";
    const pulseConfig = {
      xRequester: 'webapp',
      hmacKey: sdkEnv === 'production' ? 'ad51033b2d8446abb094183b58968380' : '535e9fbf2b7a46469f63821030a9cd6f',
    };  
    window.paytm = window.paytm || { aQ: [], analytics: {} };
    window.paytm.analytics.addEvent =
      window.paytm.analytics.addEvent ||
      function (event) {
        window.paytm.aQ.push(event);
      };
    window.addEventListener("sdk-config-loaded", function (e) {
      window.paytm.analytics.configureAnalyticsSDK &&
      window.paytm.analytics.configureAnalyticsSDK("paytm-web", `${sdkEnv}`, pulseConfig);
    });
  }
}

export async function addPulseEvent({
  event = "custom_event",
  screenName = window.location.pathname,
  operator_id = process &&
    process.env &&
    window &&
    typeof window !== "undefined" &&
    JSON.parse(localStorage.getItem("operator-id")),
  ...restData
}) {
  const payload = {
    event: "custom_event",
    screenName,
    vertical_name: "OPERATOR_DASHBOARD",
    event_label: operator_id,
    ...restData,
  };
  window &&
    window.paytm &&
    window.paytm.analytics &&
    window.paytm.analytics.addEvent(payload);
}

export const opdbGTM = {
  loggedIn(via_route_support) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_login",
      event_label5: via_route_support,
    });
  },
  tabClicked(tab) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: tab,
    });
  },
  payoutSearchClicked(start, end) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_payout_search_clicked",
      event_label2: start,
      event_label3: end,
    });
  },
  cumulativeDownloadClicked(startDate, endDate) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_payout_cumulative_download_clicked",
      event_label2: startDate,
      event_label3: endDate,
    });
  },
  payoutDownloadClicked() {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_payout_download_clicked",
    });
  },
  createDealClicked() {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_create_new_deal_clicked",
    });
  },
  dealsSrcSearchClicked(src, dest, via_route_support) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_create_deal_source_destination_search_clicked",
      event_label2: src.name,
      event_label3: dest.name,
      event_label5: via_route_support,
    });
  },
  dealCreateClicked(dealType, discountType, value) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_deal_create_clicked",
      event_label2: dealType,
      event_label3: discountType,
      event_label4: value,
    });
  },
  driverDetailsSearchClicked() {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_driver_details_search_clicked",
    });
  },
  refreshSubmitClicked(src, dest, date, via_route_support) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_inventory_refresh_submit_clicked",
      event_label2: src.name,
      event_label3: dest.name,
      event_label4: date.format("YYYY-MM-DD"),
      event_label5: via_route_support,
    });
  },
  ratingsSearchClicked(src, dest) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_ratings_reviews_search_clicked",
      event_label2: src,
      event_label3: dest,
    });
  },
  routeLevelRatingsPage() {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: "od_rr_service_level_pageload",
    });
  },
  performanceTabClicked(tab, dealTypes, graphsVisible) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: tab,
      event_label2: dealTypes,
      event_label3: graphsVisible,
    });
  },
  ongoingDealsTabClicked(tab) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: tab,
    });
  },
  competitorDealsTabClicked(tab) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: tab,
    });
  },
  competitorRouteSearch(tab, src, dest, numberOflistings) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: tab,
      event_label2: src,
      event_label3: dest,
      event_label4: numberOflistings,
    });
  },
  restStopsAdded(src, dest) {
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: 'od_rest_stops_added',
      event_label2: src || '',
      event_label3: dest || '',
    });
  },

   askReview() {    
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: 'od_rnr_ask_review',
    });
  },
  askReviewSearch(src, dest) {    
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: 'od_rnr_ask_review_search',
      event_label2: src || '',
      event_label3: dest || '',
    });
  },
  askReviewWhatsapp() {    
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: 'od_rnr_ask_review_whatsapp',
    });
  },
  askReviewEmail() {    
    addPulseEvent({
      event_category: "operator_dashboard",
      event_action: 'od_rnr_ask_review_email',
    });
  }
};
